export const ApiJobs = {
    getJobs: params => ({
        url: '/jobs',
        method: 'GET',
        params
    }),
    getJob: id => ({
        url: `/jobs/${id}`,
        method: 'GET'
    }),
    getJobDetails: id => ({
        url: `/getJobDetails?job_id=${id}`,
        method: 'GET'
    }),
    getActiveJobs: params => ({
        url: '/getActiveJobs',
        method: 'GET',
        params
    }),
    getCompletedJobs: params => ({
        url: '/getCompletedJobs',
        method: 'GET',
        params
    }),
    create: (data) => ({
        url: '/jobs',
        method: 'POST',
        data
    }),
    update: (id, data) => ({
        url: `/jobs/${id}`,
        method: 'PUT',
        data: {
            ...data
        }
    }),
    delete: (id, data) => ({
        url: `/deleteJob`,
        method: 'PUT',
        data: {
            job_id: id,
            ...data
        }
    })
};